// deepCopy
function _deepCopy(data, options, __deepCopy__) {
    const t = typeOf(data);
    let o,
        // copy 选项
        {
            exclude = [], // 需要排除的属性
            depth = -1, // copy深度
            keepNull = true // 是否保留空值(null、undefined)
        } = options

    if (t === 'array') {
        o = [];
    } else if (t === 'object') {
        o = {};
    } else {
        return data;
    }

    // 层级+1
    __deepCopy__.depth++
    // 超出最大复制层级
    if (depth >= 0 && __deepCopy__.depth > depth) {
        return o;
    }

    var val
    if (t === 'array') {
        for (let i = 0; i < data.length; i++) {
            val = _deepCopy(data[i], options, __deepCopy__)

            // 空值判断
            if (keepNull || (type(val) != "null" && type(val) != "undefined")) {
                o.push(val)
            }
        }
    } else if (t === 'object') {
        for (let i in data) {
            // 字段排除
            if (exclude == "all" || exclude.indexOf(i) >= 0) {
                void(0)
            } else {
                val = _deepCopy(data[i], options, __deepCopy__)
                // 空值判断
                if (keepNull || (type(val) != "null" && type(val) != "undefined")) {
                    o[i] = val
                }
            }
        }
    }
    return o;
}

export function deepCopy(data, options = {}) {
    // 递归数据
    var __deepCopy__ = {
        depth: -1
    }

    return _deepCopy(data, options, __deepCopy__)
}

// 返回对象类型
export function type(obj) {
    return (obj === null || obj === undefined) ? String(obj) : Object.prototype.toString.call(obj).match(/\[object (\w+)\]/)[1].toLowerCase()
}

// Pixel
export function Pixel() {
    var args = [...arguments]

    // (x, y)
    if (args.length == 2) {
        return new AMap.Pixel(...args)
    }

    if (args.length == 1) {
        var pixel = args[0]

        // [x, y]
        if (type(pixel) == "array") {
            return new AMap.Pixel(...pixel)
        }

        // {x, y}
        if (type(pixel) == "object") {
            return new AMap.Pixel(pixel.x, pixel, y)
        }
    }

    return null
}

// Size
export function Size(size) {
    var args = [...arguments]

    // (width, height)
    if (args.length == 2) {
        return new AMap.Size(...args)
    }

    if (args.length == 1) {
        var size = args[0]

        // [width, height]
        if (type(size) == "array") {
            return new AMap.Size(...size)
        }

        // {width, height}
        if (type(size) == "object") {
            return new AMap.Size(size.width, size.height)
        }
    }

    return null
}

// debounce 将函数包装为延迟执行函数，如果在该函数执行前又触发了调用，则重新计时
export function debounce(cb, waiting = 0) {
    var timerId = null,
        wrap = function() {
            var me = this,
                args = Array.prototype.slice.call(arguments, 0)

            wrap.reset()
            timerId = setTimeout(function() {
                cb.call(me, ...args)
                timerId = null
            }, waiting)
        }

    wrap.reset = function() {
        if (timerId) {
            window.clearTimeout(timerId)
            timerId = null
        }
    }

    timerId = null

    return wrap
}